"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MenuTabs = function (_a) {
    var tabs = _a.tabs, onChange = _a.onChange, defaultValue = _a.defaultValue;
    var _b = (0, react_1.useState)(defaultValue || tabs[0].value), activeTab = _b[0], setActiveTab = _b[1];
    var _c = (0, react_1.useState)({
        width: 0,
        transform: 'translateX(0px)',
    }), highlightStyle = _c[0], setHighlightStyle = _c[1];
    var containerRef = (0, react_1.useRef)(null);
    var tabRefs = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(function () {
        var index = tabs.findIndex(function (tab) { return tab.value === activeTab; });
        var currentTab = tabRefs.current[index];
        var container = containerRef.current;
        if (currentTab && container) {
            var tabRect = currentTab.getBoundingClientRect();
            var containerRect = container.getBoundingClientRect();
            var offsetLeft = tabRect.left - containerRect.left;
            setHighlightStyle({
                width: tabRect.width,
                transform: "translateX(".concat(offsetLeft, "px)"),
            });
        }
    }, [activeTab, tabs]);
    var handleClick = function (value) {
        setActiveTab(value);
        if (onChange)
            onChange(value);
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container, ref: containerRef },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.highlight, " ").concat(styles_module_scss_1.default["tab-".concat(activeTab)]), style: highlightStyle }),
        tabs.map(function (tab, idx) { return (react_1.default.createElement("div", { key: tab.value, ref: function (el) { return (tabRefs.current[idx] = el); }, className: "".concat(styles_module_scss_1.default.tab, " ").concat(activeTab === tab.value ? styles_module_scss_1.default.active : ''), onClick: function () { return handleClick(tab.value); } },
            react_1.default.createElement("span", null, tab.label))); })));
};
exports.default = MenuTabs;
